import React, { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import * as yup from 'yup';
import InputField from '../input-field/input-field';

type AllowedValidationValues =
  | 'symbol'
  | 'eight'
  | 'capital'
  | 'small'
  | 'digit';

interface PasswordFieldProps {
  control: Control<any>;
  name: string;
  label: string;
  className?: string;
}

export const passwordSchema = yup
  .string()
  .required()
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/);

const Password: React.FC<PasswordFieldProps> = ({
  control,
  name,
  ...props
}) => {
  const [passwordTip, setPasswordTip] = useState<any>();
  const validationArray: AllowedValidationValues[] = [];

  const validatePassword = (password: string) => {
    const symbols = /[^a-zA-Z0-9]/;
    const capitalLetter = /[A-Z]/;
    const smallLetter = /[a-z]/;
    const digit = /\d/;

    if (symbols.exec(password)) {
      validationArray.push('symbol');
    }
    if (capitalLetter.exec(password)) {
      validationArray.push('capital');
    }
    if (smallLetter.exec(password)) {
      validationArray.push('small');
    }
    if (digit.exec(password)) {
      validationArray.push('digit');
    }
    if (password.length >= 8) {
      validationArray.push('eight');
    }

    setPasswordTip(
      <p className='small-text bold'>
        <span className={validationArray.includes('eight') ? 'green' : 'red'}>
          mindestens 8 Zeichen lang,
        </span>{' '}
        <span className={validationArray.includes('capital') ? 'green' : 'red'}>
          einen Großbuchstaben,
        </span>{' '}
        <span className={validationArray.includes('small') ? 'green' : 'red'}>
          einen Kleinbuchstaben,
        </span>{' '}
        <span className={validationArray.includes('digit') ? 'green' : 'red'}>
          eine Zahl
        </span>{' '}
        <span className={validationArray.includes('symbol') ? 'green' : 'red'}>
          und ein Sonderzeichen (z.B. !, @, #, $)
        </span>
      </p>,
    );
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...rest } }) => (
        <>
          <InputField
            {...props}
            {...rest}
            type='password'
            onChange={(e) => {
              validatePassword(e.target.value);
              return onChange(e);
            }}
            withErrorMessage={false}
          />
          {passwordTip}
        </>
      )}
    />
  );
};

export default Password;
